import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl, UntypedFormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SignaturePadComponent as LibSignaturePadComponent } from '@almothafar/angular-signature-pad';
import { PdfMakeWrapper } from 'pdfmake-wrapper';

// import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from "@techiediaries/ngx-qrcode";
import { ToastrService } from 'ngx-toastr';
import { debounceTime, takeUntil } from 'rxjs/operators';
import domtoimage from 'dom-to-image';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
const pdfMakeAny: any = (pdfMake as any).default || pdfMake;
pdfMakeAny.vfs = (pdfFonts as any)?.pdfMake?.vfs || (pdfFonts as any)?.vfs || (pdfFonts as any)?.default || pdfFonts;

import { EmailTemplate } from '../../../../../constants/email-template';

import { User } from '../../../../../models/user.model';
import { AgreementModel } from '../../../../../models/customers/agreement.model';
import { ClientModel } from '../../../../../models/customers/client.model';
import { Subject } from 'rxjs';
import { AgreementResult, ProjectResult } from '../presenter/interfaces/agreement.result';
import { IsRequestComplete } from '../../../../../interfaces/isrequest-complete';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { AgreementRequest, CreateProjectRequest, ProjectRequest } from '../presenter/interfaces/agreement.request';
import { AgreementPresenter } from '../presenter/agreement.presenter';
import { ClientPresenter } from '../../../client/presenter/client.presenter';
import { GetClientsRequest, GetClientsBySalePersonIDRequest, UpdateClientRequest } from '../../../client/presenter/interfaces/client.request';
import { GlobalPresenter } from '../../../../../services/global/presenter/global.presenter';
import { GlobalRequest } from '../../../../../services/global/presenter/global.request';
import { GetUsersRequest } from '../../../../core/usuarios/presenter/interfaces/user.request';
import { UserPresenter } from '../../../../core/usuarios/presenter/user.presenter';
import { ProjectFormFields } from '../../../../../constants/forms/project.fields';
import { IFormInputs } from '../../../../../interfaces/forms.interface';
import { PdfUtilities } from '../../../../../utilities/pdf/pdf.utilities';
import { ProjectModel } from '../../../../../models/customers/project.model';

// Grape Zone
import * as wjcInput from '@grapecity/wijmo.input';
import { DialogsService } from '../../../../../services/dialogs.service';


@Component({
    selector: 'app-agreement',
    templateUrl: './agreement.component.html',
    styleUrls: ['./agreement.component.scss'],
    standalone: false
})
export class AgreementComponent implements AgreementResult, ProjectResult, ProjectRequest, IsRequestComplete, OnInit, OnDestroy {

  @ViewChild('inputfile') inputfile: ElementRef;
  @ViewChild('signature') signaturePad: LibSignaturePadComponent;
  @ViewChild('msa') msaInput: wjcInput.AutoComplete;
  @ViewChild('payment') paymentInput: wjcInput.AutoComplete;
  @ViewChild('city') cityInput: wjcInput.AutoComplete;
  @ViewChild('state') stateInput: wjcInput.AutoComplete;


  private requestGlobal: GlobalRequest;
  private request: AgreementRequest;
  private requestGetClients: GetClientsRequest;
  private requestGetClientsBySP: GetClientsBySalePersonIDRequest;
  private requestUpdateClient: UpdateClientRequest;
  private requesCreateProject: CreateProjectRequest;
  private requestGetUsersRequest: GetUsersRequest;
  private requestProject: ProjectRequest;

  destroy$ = new Subject();

  selectHide: boolean = true;
  isDisabled: boolean = true;
  btnFormHide: boolean = true;
  regresar: string = '/business';
  tipoMenu: string;
  projectForm!: UntypedFormGroup;
  clientSelected: ClientModel;
  agreement: AgreementModel;
  public usuario: User;
  ROLE = '';
  projects_arr = [];
  projects_arr_api = [];
  clients_arr = [];
  files_arr: File[] = [];
  signaturePad_str: string = '';
  signaturePadOptions: Object = {
    'minWidth': 1,
    'canvasWidth': 410,
    'canvasHeight': 200,
  };
  form!: UntypedFormGroup;
  inputs: IFormInputs = {
    name_client_select: {
      formControlNameValue: 'name_client_select',
      label: 'Select New Prospect',
      type: 'text'
    },
  }
  pdfUtilities: PdfUtilities = new PdfUtilities();
  tipoElemento = 'canvas'; // NgxQrcodeElementTypes.CANVAS;
  correctionLevel = 'H'; // NgxQrcodeErrorCorrectionLevels.HIGH;
  valor: string = "";
  Qr = [];
  dd: any;
  fileQr: File[] = [];
  fileData: File | null = null;
  fileAnnex: File[] = [];
  // zoho config
  zoho: any = false;

  // draft config
  draft: any = false;
  is_draft: boolean = false;
  draftData: any = null;

  // new changes
  payment_methods: any = [];

  public msa_arr = [
    { name: '', id_project: '' }
  ]

  modal_control: any = false;
  msa_control: any = true;
  selectedTypeAgreement: any;
  selectedMsa: any;
  signControl: any = false;
  mainAddress: boolean = false;
  cities: any = [];
  states: any = [
    { name: 'florida' }
  ];

  client_data: any;

  constructor(private fb: UntypedFormBuilder,
    private router: Router,
    private toastr: ToastrService,
    public activatedRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private globalPresenter: GlobalPresenter,
    private agreementPresenter: AgreementPresenter,
    private clientPresenter: ClientPresenter,
    private userPresenter: UserPresenter,
    private dialogsService: DialogsService
  ) {

    this.requestGlobal = globalPresenter;
    globalPresenter.setComponent(this);

    this.request = agreementPresenter;
    agreementPresenter.setRequestCompleteComponent(this);
    agreementPresenter.setComponent(this);

    this.requesCreateProject = agreementPresenter;
    this.requestProject = agreementPresenter;
    agreementPresenter.setRequestProjectComponent(this);

    this.requestGetClients = clientPresenter;
    this.requestGetClientsBySP = clientPresenter;
    this.requestUpdateClient = clientPresenter;
    clientPresenter.setComponent(this);
    clientPresenter.setRequestCompleteComponent(this);

    this.requestGetUsersRequest = userPresenter;
    userPresenter.setComponent(this);
    userPresenter.setRequestCompleteComponent(this);

    this.zoho = false;
  }

  getProject(id: any): Promise<ProjectModel> {
    throw new Error('Method not implemented.');
  }

  isRequestComplete(status: boolean, error?: HttpErrorResponse, data?: object | any[]): void {
    console.log(error);
    if (error) this.toastr.error(error.error.msg ?? 'Error');
  }

  isEditedResponseSuccess(): void {
    this.fileData = null;
    this.projects_arr_api = [];
    this.projects_arr = [];
  }

  isCreateProjectResponse(response: HttpResponse<any>) {
    this.projects_arr_api.push(response['project']);
  }

  async getResponse(response: HttpResponse<any>): Promise<void> {
    if (response['agreement']) {
      this.agreement = response['agreement'];

      if (this.draft) {
        this.saveProjectDraft(this.agreement);
      } else {
        await this.newProjects(this.agreement);
        if (!this.fileData) return
        await this.requestGlobal.uploadFile(this.fileData, 'sa-supports', this.agreement._id, false);
      }

      this.toastr.success(response['msg']);

    }
  }

  ngOnInit(): void {
    this.tipoMenu = this.activatedRoute.snapshot.paramMap.get('tipoMenu');
    this.usuario = this.requestGlobal.getUser();
    this.ROLE = this.usuario.role;
    this.initForm();
    this.loadCustomers();
    this.activatedRoute.params.subscribe(({ id }) => this.loadClientInfo(id));
    this.formControlsObserve();

    this.request.getMasterAgreements().then((result: any) => {

      result.map((item: any, index: any) => {
        this.msa_arr.push({ name: item.ident_GUI + ' ' + item.name_project, id_project: item.ident_GUI });
      })

    }).catch((error) => console.log(error));

    this.requestGlobal.getPaymentsMethods().then((payments) => {
      this.payment_methods = payments.payment_methods;
    })

    this.requestGlobal.getCitySelect().then((cities: any) => {
      this.cities = cities;
    });

    this.requestGlobal.getStatesSelect().then((states: any) => {
      this.states = states;
    });

  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  formControlsObserve(): void {

    this.projectForm.controls.price.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(res => {
      if (res) {
        this.clearValidatior('per_percentage');
        this.resetField('per_percentage');
      }
    });

    this.projectForm.controls.per.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(res => {
      if (res) {
        this.clearValidatior('per_percentage');
        this.resetField('per_percentage');
      }
    });

    this.projectForm.controls.per_percentage.valueChanges.pipe(takeUntil(this.destroy$), debounceTime(1000)).subscribe(res => {
      if (!res && !this.hasRequiredField(this.projectForm.controls.price) && !this.hasRequiredField(this.projectForm.controls.per)) {
        this.setFieldsValidations();

        if (!this.projectForm.controls.price.value) {
          this.setFieldErrorAndMarks('price');
        }

        if (!this.projectForm.controls.per.value) {
          this.setFieldErrorAndMarks('per');
        }
      }

      if (res && this.containsOnlyNumbers(res)) {
        this.removeFieldsValidations();
        this.transformAmount();
        this.resetField('price');
        this.resetField('per');
      }
    });

  }

  private setFieldsValidations(): void {
    this.setValidatorRequired('price');
    this.setValidatorRequired('per');
  }
  private removeFieldsValidations(): void {
    this.clearValidatior('price');
    this.clearValidatior('per');
  }
  private clearValidatior(field: string): void {
    this.projectForm.controls[field].clearValidators();
    this.projectForm.controls[field].setErrors(null);
  }
  private setValidatorRequired(field: string): void {
    this.projectForm.controls[field].setValidators(Validators.required);
  }
  private setFieldErrorAndMarks(field: string): void {
    this.projectForm.controls[field].markAsDirty();
    this.projectForm.controls[field].markAsTouched();
    this.projectForm.controls[field].setErrors({ required: true });
  }
  private hasRequiredField(abstractControl: AbstractControl): boolean {
    if (abstractControl.validator) {
      const validator = abstractControl.validator({} as AbstractControl);
      if (validator && validator.required) {
        return true;
      }
    }
    return false;
  }
  private resetField(field: string): void {
    this.projectForm.controls[field].reset('');
  }
  private containsOnlyNumbers(str: string): boolean {
    return /^\d+$/.test(str);
  }

  getSalesPersonName(): string {
    if (!this.clientSelected) return 'NA';
    return this.ROLE == 'SALESPER_ROLE' ?
      this.usuario.name :
      this.clientSelected.sales_person;
  }
  getSalesPersonID(): string {
    if (!this.clientSelected) return 'NA';
    return this.ROLE == 'SALESPER_ROLE' ?
      this.usuario.uid :
      this.clientSelected.sales_person_id;
  }
  transformAmount(): void {
    if (this.porcentageNoValido.value.includes('%')) {
      this.porcentageNoValido.value.replace(1, -1);
    } else {
      this.porcentageNoValido.setValue(`${this.porcentageNoValido.value}%`)
      this.porcentageNoValido?.updateValueAndValidity();
    }
  }

  async loadCustomers(): Promise<any> {
    if (this.ROLE == 'SALESPER_ROLE') {
      this.clients_arr = await this.requestGetClientsBySP.getClientsBySalePersonID(this.usuario.uid);
    } else {
      this.clients_arr = (await this.requestGetClients.getClients())
        .map((value) => (
          {
            ...value,
            name: value.name_client_address,
            id: value._id,
            htmlId: value._id
          }));
    }
  }

  initForm() {
    this.projectForm = this.fb.group(ProjectFormFields);
    this.form = this.fb.group({ name_client_select: new UntypedFormControl('', Validators.required) });
  }
  get perNoValido(): boolean {
    return this.projectForm.get('per').invalid && this.projectForm.get('per').touched;
  }
  get priceNoValido() {
    return this.projectForm.get('price');
  }
  get porcentageNoValido() {
    return this.projectForm.get('per_percentage');
  }
  get isBtnDisabled() {
    return !(this.projects_arr.length > 0);
    return !(this.projects_arr.length > 0 && (this.signaturePad_str || this.inputfile.nativeElement.disabled));
  }
  get isInputDisabled() {
    return !(this.projects_arr.length > 0 && !this.signaturePad_str && this.isDisabled);
  }


  // carga de cliente. 
  async loadClientInfo(id: string) {
    const client = this.client_data = await this.request.getClientInfo(id);

    console.log(client);

    if (!client) {
      return this.router.navigateByUrl(`/dashboard`);
    }

    this.clientSelected = client;
    delete client.contact_name;

    this.projectForm.patchValue({
      ...client,
      ident_client: client._id,
      name_project: client.name_client,
      client: client
    });

    this.valor = client.ident_GUI;

    this.requestProject.getProject(client.ident_GUI).then((response: any) => {

      if (response && response.project && response.project.status == 'draft') {

        console.log('draft find')

        this.is_draft = true;

        this.projectForm.patchValue({
          ...response.project,
          per: (response.project.per_gallon == 'YES') ? 'per_gallons' : 'per_pounds',
          price: response.project.price.replace('$', ''),
        })

        this.projects_arr.push(response.project);

        this.draftData = response.project;

        this.msaInput.selectedValuePath = 'id_project';
        this.msaInput.selectedValue = response.project.master_agreement.id_project;
        this.msaInput.refresh();

        this.paymentInput.selectedValuePath = '_id';
        this.paymentInput.selectedValue = response.project.payment_method;
        this.paymentInput.refresh();

      }

    });
  }

  initAutoComplete(ac: wjcInput.AutoComplete) {
    // console.log('init auto', this.draftData);
    // ac.selectedValue  = this.draftData.master_agreement;
    //this.msaInput.selectedIndex = 5;
  }

  async newAgreement() {
    if (!this.clientSelected.email) {
      return this.dialogsService.openFeedbackSuccess({ title: 'Error', msg: "This customer does not have an associated email address, please update the customer information." })
    }
    if (!this.usuario.signature) {
      return this.toastr.error('User Signature missing');
    }

    let blankSign = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8//dvPQAJdgN6GL8JXgAAAABJRU5ErkJggg==';

    const code = new Date().getMilliseconds();

    let signature = '';
    if (this.msa_control == true) {
      signature = blankSign;
    } else {
      signature = (this.zoho) ? blankSign : await this.signaturePad.toDataURL();
    }
    const has_support = this.fileData ? true : false
    const formData = new FormData();
    formData.append('name_agreement', `A-${code}`);
    formData.append('sales_person', this.getSalesPersonName());
    formData.append('sales_person_id', this.getSalesPersonID());
    formData.append('signature', signature);
    formData.append('my_signature', this.usuario.signature);
    formData.append('has_support', has_support.toString());
    if (this.fileAnnex) {
      this.fileAnnex.forEach((file) => {
        formData.append('attachments_files', file, file.name);
        // 'attachments_files' es la clave que el backend espera.
      });
    }
    //this.fileAnnex && formData.append('attachments_files', this.fileAnnex, this.fileAnnex.name); // Clave 'file' (debe coincidir con el backend)
    const _agreement = {
      name_agreement: `A-${code}`,
      sales_person: this.getSalesPersonName(),
      sales_person_id: this.getSalesPersonID(),
      signature: signature,
      my_signature: this.usuario.signature,
      has_support: this.fileData ? true : false,
      attachments_files: [this.fileAnnex]
    };

    let name_project = this.clientSelected.name_client;
    let confirmMessage = 'KITEPro will process the creation of the Services Agreement for the customer "' + name_project + '". Could you please confirm if you want to proceed with this?';
    let confirmProccess = confirm(confirmMessage)


    if (confirmProccess) {
      this.generarPdf();
      this.request.newAgreement(formData);
      this.router.navigate(['/dashboard', {}]);
    }

  }

  /**saving draft */

  saveDraft() {
    if (!this.usuario.signature) {
      return this.toastr.error('User Signature missing');
    }

    const code = new Date().getMilliseconds();
    const _agreement = {
      name_agreement: `A-${code}`,
      sales_person: this.getSalesPersonName(),
      sales_person_id: this.getSalesPersonID(),
      my_signature: this.usuario.signature,
      has_support: this.fileData ? true : false,
      status: 'draft'
    };

    this.draft = true;
    //this.request.newAgreement(_agreement);
    this.router.navigate(['/uco/business/megamenu2', {}]);

  }

  /**
   * 
   * Sign Draft Agreement
   * 
   */

  async completeAgreement() {

    this.generarPdf();

    if (!this.fileData) { } else {
      await this.requestGlobal.uploadFile(this.fileData, 'sa-supports', this.agreement._id, false);
    }


    this.projects_arr.forEach(async (_project, index) => {

      if (this.zoho) {
        _project.client.agreement_status = 'Pending';
        _project.zoho = true;
        _project.signature = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8//dvPQAJdgN6GL8JXgAAAABJRU5ErkJggg==';
        this.draftData['zoho'] = true;
      } else {
        _project.client.agreement_status = 'Signed';
        _project.zoho = false;
        this.draftData['zoho'] = false;
        this.requestUpdateClient.updateClient(_project.client);
        _project.signature = this.signaturePad.toDataURL();
      }

      _project.my_signature = this.draftData.agreement.my_signature;
      var pdf = this.pdfUtilities.downloadPDFSA(_project);

      //this.toSendPDF(pdf, this.draftData);
      //pdf.create().download(`${_project.name_project}-SA`);

      this.router.navigate(['/uc/agreements', {}]);

    });


  }

  ngAfterViewInit(): void {
    // this.signaturePad.set('minWidth', 1);
    // this.signaturePad.set('backgroundColor', '#FFFFFF');
    this.signaturePad.clear();
  }

  drawComplete() {
    this.signaturePad_str = this.signaturePad.toDataURL();
  }

  drawStart() {
    console.log('begin drawing');
  }

  clearPad() {
    if (this.signaturePad) {
      this.signaturePad.clear();
      this.signaturePad_str = '';
    }
  }

  async addProject(): Promise<any> {

    const selectControl = this.form.get('name_client_select');

    this.projectForm.get('name_client_address').enable();

    if (this.projects_arr.length == 10) {
      this.toastr.warning('Max 10 Prospects');
      return;
    }

    const _project = this.projects_arr.find(item => item.ident_client == selectControl.value._id);
    if (_project != undefined) {
      this.toastr.warning('The Prospect already exists.');
      return;
    }

    if (!this.selectHide) {
      if (!selectControl.value) {
        this.toastr.error('Error Select New Prospect');
        return;
      }

      const _client = this.clients_arr.find(item => item._id == selectControl.value._id);

      this.projectForm.patchValue({
        ..._client,
        name_project: _client.name_client,
        ident_client: _client._id,
        client: _client
      })

    }

    if (this.projectForm.invalid) {
      return Object.values(this.projectForm.controls).forEach(control => {
        control.markAsTouched();
      });
    }

    const _requirements = this.projectForm.controls.special_requirements.value ? this.projectForm.controls.special_requirements.value : '--';
    this.projectForm.get('special_requirements').setValue(_requirements);

    const project = {
      ...this.projectForm.value,
      price: typeof this.projectForm.value.price === 'number' ? `$${this.projectForm.value.price}` : '',
      per_gallon: this.projectForm.get('per').value == 'per_gallons' ? 'YES' : 'NO',
      per_pounds: this.projectForm.get('per').value == 'per_pounds' ? 'YES' : 'NO',
    }
    delete project.per;

    this.projects_arr.push(project);
    this.selectHide = false;
    this.projectForm.reset({ sales_person: this.getSalesPersonName(), sales_person_id: this.getSalesPersonID(), });

    this.form.reset();
    this.form.updateValueAndValidity();
    this.cdRef.detectChanges();

    this.isDisabled = true;
    this.getBase64();
  }

  removeProject(project): void {
    this.projects_arr = this.projects_arr.filter(item => item.name_client_address !== project.name_client_address);
  }

  editProjectDataTable(_project): void {
    this.selectHide = true;
    this.btnFormHide = false;
    let price = null;
    let pre = '';
    if (typeof _project.price === 'string') {
      price = _project.price.startsWith('$') ? Number(_project.price.split('$')[1]) : _project.price;
    }
    if (_project.per_percentage === '') {
      pre = _project.per_gallon === 'YES' ? 'per_gallons' : 'per_pounds'
    }
    this.projectForm.patchValue({
      ..._project,
      price: price ?? _project.price,
      per: pre,
      name_client_address: _project.client.name_client_address
    });
  }

  editProjectData(): void {
    const i = this.projects_arr.map(x => x.ident_client).indexOf(this.projectForm.controls.ident_client.value);
    const project = {
      ...this.projectForm.value,
      price: typeof this.projectForm.value.price === 'number' ? `$${this.projectForm.value.price}` : '',
      per_gallon: this.projectForm.get('per').value == 'per_gallons' ? 'YES' : 'NO',
      per_pounds: this.projectForm.get('per').value == 'per_pounds' ? 'YES' : 'NO',
    }
    delete project.per;
    this.projects_arr[i] = project;
    this.selectHide = false;
    this.btnFormHide = true;
    this.projectForm.reset({ sales_person: this.getSalesPersonName(), sales_person_id: this.getSalesPersonID(), });
    this.form.reset();
    this.form.updateValueAndValidity();
    this.cdRef.detectChanges();
  }

  editCancel(): void {
    this.selectHide = false;
    this.btnFormHide = true;
    this.projectForm.reset({ sales_person: this.getSalesPersonName(), sales_person_id: this.getSalesPersonID(), });
    this.form.reset();
    this.form.updateValueAndValidity();
    this.cdRef.detectChanges();
  }


  saveProjectDraft(agreetment) {

    this.projects_arr.forEach(async (_project, index) => {

      _project.agreement_id = agreetment._id;
      _project.agreement = agreetment;
      _project.status = 'draft';
      const _newProject = await this.requesCreateProject.newProject(_project);

    })

  }

  async newProjects(agreetment) {
    this.projects_arr_api = [];
    this.files_arr = [];
    this.fileQr = [];

    this.projects_arr.forEach(async (_project: any, index: any) => {
      _project.agreement_id = agreetment._id;
      _project.agreement = agreetment;
      _project.zoho = this.zoho;
      _project.status = 'New';
      _project.typeAgreement = this.selectedTypeAgreement;

      const _newProject = await this.requesCreateProject.newProject(_project);


      if (this.zoho) {
        _project.client.agreement_status = 'Pending';
        _project.zoho = true;
        _project.signature = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8//dvPQAJdgN6GL8JXgAAAABJRU5ErkJggg==';
      } else {
        _project.client.agreement_status = 'NA';
        _project.zoho = false;
        //this.requestUpdateClient.updateClient(_project.client);
        _project.signature = agreetment.signature; //this.signaturePad.toDataURL();
      }

      _project.my_signature = agreetment.my_signature;
      var pdf = this.pdfUtilities.downloadPDFSA(_project);

      //this.toSendPDF(pdf, _newProject);
      //pdf.create().download(`${_project.name_project}-SA`);

    });

    setTimeout(() => {
      this.clearPad();
      this.agreement.projects = this.projects_arr_api;
      this.request.editAgreement(this.agreement);
    }, 2000);

  }

  setFile(_file: File) {
    const nombreCortado = _file.name.split('.');
    const extensionArchivo = nombreCortado[nombreCortado.length - 1];
    const extensionesValida = ['png', 'jpg', 'jpeg', 'gif', 'pdf'];
    if (!extensionesValida.includes(extensionArchivo)) {
      return this.toastr.error(`${extensionArchivo} no valid`);
    }
    if (!_file) {
      return this.fileData = null;
    }
    this.fileData = _file;
  }

  setFileAttach(_file: File[]) {
    this.fileAnnex = [...this.fileAnnex, ..._file];
  }

  showFiles() {
    const _input = this.inputfile.nativeElement;
    _input.value = '';
    this.isDisabled = false;
  }

  private toSendPDF(pdf: PdfMakeWrapper, _project): void {
    const pdfDocGenerator = pdf.create();
    pdfDocGenerator.getBlob(async (document) => {

      var file = new File([document], `${_project.name_project}.pdf`, {
        type: "application/pdf",
      });

      await this.requestGlobal.uploadFile(file, 'agreements', _project._id, this.zoho);

      if (!this.zoho) {
        this.files_arr.push(file);
        if (this.projects_arr.length == this.files_arr.length) {
          this.setEmailData(_project.client.email);
        }
      }

    });
  }

  async setEmailData(_clientEmail): Promise<any> {
    const _emails = [_clientEmail, this.usuario.email];
    const _emailsQr = [];
    const users = await this.requestGetUsersRequest.getUsers();
    if (users) {
      users.forEach(user => {
        if (user.role == 'SALESMAN_ROLE' || user.role == 'SERVMAN_ROLE') {
          _emails.push(user.email);
        }
        if (user.role == 'INSLLTEAM_ROLE') {
          _emailsQr.push(user.email);
        }
      });
      this.sendingEmail(_emails.join(), this.files_arr);
      this.sendingEmail(_emailsQr.join(), this.fileQr);
    }
  }

  sendingEmail(_emails: string, files: File[]): void {
    let json = {
      email: _emails,
      bodyHtml: EmailTemplate.HTML_BODY_SA,
      attachment: _emails
    }
    this.requestGlobal.sentEmail(_emails, json.bodyHtml, files);
  }

  async generarPdf(): Promise<any> {
    this.Qr.forEach(codeQr => {
      setTimeout(() => {
        this.dd = {
          content: [
            {
              image: codeQr,
              margin: [-78, 0, 0, 0],
            },
          ]
        };
        let pdf = pdfMake.createPdf(this.dd);
        pdf.getBlob((document) => {
          let file = new File([document], `QR.pdf`, {
            type: "application/pdf",
          });
          this.fileQr.push(file);
        });
      }, 1000)

    });
    this.Qr = [];
  }

  async getBase64(): Promise<any> {
    let node = document.getElementById('qr');

    domtoimage.toPng(node).then((dataUrl) => {
      this.Qr.push(dataUrl);
    }).catch(function (error) {
      console.error('oops, something went wrong!', error);
    });
  }

  setItemSelected(itemSelected): void {
    this.projectForm.get('name_client_address').setValue(itemSelected.name)
    this.valor = itemSelected.ident_GUI;
  }


  closeModal() {
    this.modal_control = true;
  }

  selectType(type: string) {
    if (type == 'msa') {
      this.msa_control = false;
      this.selectedTypeAgreement = 'msa';
    } else if (type == 'single') {
      this.msa_control = false;
      this.selectedTypeAgreement = 'single';
    } else if (type == 'adendum') {
      this.msa_control = true;
      this.selectedTypeAgreement = 'asa';
      this.signControl = true;
    }

    this.closeModal();
  }


  sameData() {
    this.mainAddress = !this.mainAddress

    this.stateInput.selectedValuePath = 'name';
    this.stateInput.selectedValue = this.client_data.state;
    this.stateInput.refresh();

    this.projectForm.patchValue({
      check_zip: this.client_data.zip_code,
      check_address: this.client_data.address,
      check_city: this.cities?.find(item => item.name === this.client_data.city)
    })
  }

}
